export default "__VITE_ASSET__2f391426__"